/**
 * LocalStorage helpers for remembered user preferences.
 * SDD §7.4 — Remembered defaults (NFR-USE-02).
 *
 * Stores the last-used position and apparatus so they are
 * pre-filled on the next clock-in flow.
 */

const STORAGE_PREFIX = 'shifthappens_';

const KEYS = {
  lastPosition: `${STORAGE_PREFIX}last_position`,
  lastApparatus: `${STORAGE_PREFIX}last_apparatus`,
  lastCategory: `${STORAGE_PREFIX}last_category`,
  guideDismissed: `${STORAGE_PREFIX}guide_dismissed`,
} as const;

function safeGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Storage full or unavailable — silently ignore
  }
}

export function getLastPosition(): string | null {
  return safeGet(KEYS.lastPosition);
}

export function setLastPosition(position: string): void {
  safeSet(KEYS.lastPosition, position);
}

export function getLastApparatus(): string | null {
  return safeGet(KEYS.lastApparatus);
}

export function setLastApparatus(apparatus: string): void {
  safeSet(KEYS.lastApparatus, apparatus);
}

export function getLastCategory(): string | null {
  return safeGet(KEYS.lastCategory);
}

export function setLastCategory(category: string): void {
  safeSet(KEYS.lastCategory, category);
}

export function isGuideDismissed(): boolean {
  return safeGet(KEYS.guideDismissed) === '1';
}

export function dismissGuide(): void {
  safeSet(KEYS.guideDismissed, '1');
}
